"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyJoin = void 0;
function applyJoin(factory, outer, inner, outerKeySelector, innerKeySelector, resultSelector, equalityComparer) {
    function* generator() {
        if (equalityComparer) {
            for (const outerItem of outer) {
                const outerKey = outerKeySelector(outerItem);
                for (const innerItem of inner) {
                    if (equalityComparer(outerKey, innerKeySelector(innerItem))) {
                        yield resultSelector(outerItem, innerItem);
                    }
                }
            }
        }
        else {
            const innerMap = new Map();
            for (const innerItem of inner) {
                const key = innerKeySelector(innerItem);
                const curr = innerMap.get(key);
                if (curr !== undefined) {
                    curr.push(innerItem);
                }
                else {
                    innerMap.set(key, [innerItem]);
                }
            }
            for (const outerItem of outer) {
                const key = outerKeySelector(outerItem);
                const innersToJoin = innerMap.get(key);
                if (innersToJoin !== undefined) {
                    for (let i = 0; i < innersToJoin.length; i++) {
                        yield resultSelector(outerItem, innersToJoin[i]);
                    }
                }
            }
        }
    }
    return factory.createBasicEnumerable(generator);
}
exports.applyJoin = applyJoin;
//# sourceMappingURL=applyJoin.js.map